<template>
  <div class="t-slider"></div>
</template>

<script>
export default {
  name: 't-slider',

  props: {
    value: {},

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    min: {
      type: Number,
      default: 0,
    },

    max: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style scoped lang="scss">
</style>
